// Routes both `import m from 'moment'` and `require('moment')` to the same
// callable moment function. Vite/rolldown's CJS-from-ESM interop sometimes
// hands UMD wrappers (e.g. pc-bootstrap4-datetimepicker) the moment namespace
// object instead of the callable, which breaks `moment.locale(...)`.
const moment = require('moment/moment.js');
if (typeof window !== 'undefined') {
    window.moment = window.moment || moment;
}
module.exports = moment;
module.exports.default = moment;
